import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import images from './images/images';
import lodash from 'lodash';
import {
  gaFailedAndHasDebtPrivate,
  gaAllFailedPrivate,
  gaPartiallyFailedPrivate,
  gaFailedAndHasDebtCallBackClickPrivate,
  gaFailedAndHasDebtTryAgainPrivate,
  gaAllFailedTryAgainPrivate,
  gaAllFailedCallBackClickPrivate,
  gaPartiallyFailedCallBackClickPrivate,
  gaGeneralErrorPrivate,
  gaGeneralErrorCallBackClickPrivate,
  gaPartiallyFailedTryAgainClickPrivate,
} from './gaReports';

const ErrorComponent = ({props, backToLobby, failedUpdates, banListResults, allUpdatesFailed, accountWithDebt}) => {
  useEffect(() => {
    if (!props.data.isBusinessBlock) {
      if (props.data.completed) {
        if (allUpdatesFailed) {
          if (accountWithDebt && ifFailedBansHaveDebt()) {
            gaFailedAndHasDebtPrivate();
          } else {
            gaAllFailedPrivate();
          }
        } else if (failedUpdates && !allUpdatesFailed) {
          if (accountWithDebt && ifFailedBansHaveDebt()) {
            gaFailedAndHasDebtPrivate();
          } else {
            gaPartiallyFailedPrivate();
          }
        }
      } else {
        gaGeneralErrorPrivate();
      }
    }
  }, []);

  function renderErrorReason() {
    if (!props.data.isBusinessBlock && allUpdatesFailed) {
      return <p>אופס.. העדכון נכשל</p>;
    }
    if (!props.data.isBusinessBlock && failedUpdates && !allUpdatesFailed) {
      return <p>משהו קרה ועדכון הצליח רק בחלק מהחשבונות</p>;
    }
    return (
      <p>
        זה לא היה צפוי... <br /> קרתה תקלה
      </p>
    );
  }

  function renderUpdatedAccountsReport() {
    return (
      <>
        <div className='d-flex justify-content-center'>
          <Image src={images.smallArrowOkUpdate} alt='הצלחה' style={{height: '18px', width: '18px', marginLeft: '3px', flexShrink: 0}} />
          <p>חשבונות בהם העדכון הצליח</p>
        </div>
        <div style={{background: '#eff0f1', padding: '10px'}}>
          {banListResults.map(function (updatedEntity, i) {
            if (updatedEntity?.updated == true) {
              return (
                <div
                  className={`d-flex flex-column align-items-baseline justify-content-center p-10 ${isMobile ? 'flex-column' : ''}`}
                  key={i}>
                  <div className='font-weight-bold'> חשבון {updatedEntity.ban}</div>
                  <div>{updatedEntity.desc}</div>
                </div>
              );
            }
          })}
        </div>

        <div className='d-flex justify-content-center mt-3'>
          <Image src={images.smallArrowNoUpdate} alt='איקס' style={{height: '18px', width: '18px', marginLeft: '3px'}} />
          <p>חשבונות בהם העדכון נכשל</p>
        </div>
        <div style={{background: '#eff0f1', padding: '10px'}}>
          {banListResults.map(function (updatedEntity, i) {
            if (updatedEntity?.updated == false) {
              return (
                <div
                  className={`d-flex flex-column align-items-baseline justify-content-center p-10 ${isMobile ? 'flex-column' : ''}`}
                  key={i}>
                  <div className='font-weight-bold'> חשבון {updatedEntity.ban}</div>
                  <div>{updatedEntity.desc}</div>
                </div>
              );
            }
          })}
        </div>
      </>
    );
  }

  function ifFailedBansHaveDebt() {
    var results = lodash.filter(banListResults, function (updatedEntity) {
      return updatedEntity?.updated == false && updatedEntity?.hasDebt == true;
    }).length;

    if (results > 0) return true;
    return false;
  }

  function gaCallBackClick() {
    if (!props.data.isBusinessBlock) {
      if (props.data.completed) {
        if (allUpdatesFailed) {
          if (accountWithDebt && ifFailedBansHaveDebt()) {
            gaFailedAndHasDebtCallBackClickPrivate();
          } else {
            gaAllFailedCallBackClickPrivate();
          }
        } else if (failedUpdates && !allUpdatesFailed) {
          if (accountWithDebt && ifFailedBansHaveDebt()) {
            gaFailedAndHasDebtCallBackClickPrivate();
          } else {
            gaPartiallyFailedCallBackClickPrivate();
          }
        }
      } else {
        gaGeneralErrorCallBackClickPrivate();
      }
    }
  }

  function renderRelevantDialToNumber() {
    let tel = window.Config.businessCallNumber;
    let text = `חייג אלינו ל-${window.Config.businessCallNumber} ונשמח לעזור`;

    if (!props.data.isBusinessBlock) {
      tel = accountWithDebt && (allUpdatesFailed || (!allUpdatesFailed && ifFailedBansHaveDebt())) ? `${window.Config.financeCallNumber2}` : `${window.Config.technicalSupportPhone}`;
      text =
        accountWithDebt && (allUpdatesFailed || (!allUpdatesFailed && ifFailedBansHaveDebt()))
          ? `חייג ל-${window.Config.financeCallNumber2} לנציג פיננסי`
          : `חייג אלינו ל-${window.Config.technicalSupportPhone} ונשמח לעזור`;
    }

    return (
      <p className='message-text text-center'>
        {!isMobile ? (
          <span className='d-block'>
            <span className='sub-text'>
              <span className='sub-text-icon'>
                {' '}
                <Image src={images.shape} alt='call' />
              </span>
              <span>{text}</span>
            </span>
          </span>
        ) : (
          <span className='asBtn d-block sub-text text-center' onClick={() => gaCallBackClick()}>
            <a href={`tel:${tel}`}>
              <span className='sub-text-icon'>
                {' '}
                <Image src={images.shape} alt='call' />
              </span>
              <span>{text}</span>
            </a>
          </span>
        )}
      </p>
    );
  }
  function renderTryAgainDescription() {
    let requiredDepartment = `או לפנות לשירות לקוחות בשעות הפעילות`;

    if (accountWithDebt && (allUpdatesFailed || (!allUpdatesFailed && ifFailedBansHaveDebt()))) {
      requiredDepartment = `או לפנות למוקד פיננסי בשעות הפעילות`;
    }

    return (
      <>
        <span>באפשרותך</span>
        <span onClick={() => tryUpdateAgain()} className='bold pink-text pr-1 pl-1 pointer'>
          לנסות שוב
        </span>
        <span>{requiredDepartment}</span>
      </>
    );
  }

  function renderErrorIcon() {
    if (allUpdatesFailed) {
      return (
        <Col>
          <Image src={images.failUpdate} alt='error' style={{width: '102px', height: '102px'}} className='failure-image-container' />
        </Col>
      );
    }
    return null;
  }

  function tryUpdateAgain() {
    if (!props.data.isBusinessBlock && props.data.completed) {
      if (allUpdatesFailed) {
        if (accountWithDebt && ifFailedBansHaveDebt()) {
          gaFailedAndHasDebtTryAgainPrivate();
        } else {
          gaAllFailedTryAgainPrivate();
        }
      } else if (failedUpdates && !allUpdatesFailed) {
        if (accountWithDebt && ifFailedBansHaveDebt()) {
          gaFailedAndHasDebtTryAgainPrivate();
        } else {
          gaPartiallyFailedTryAgainClickPrivate();
        }
      }
    }

    props.resetState();
    props.resetPaymentState();
    props.resetPaymentCGState();
    props.handleCurrentStep(1);
  }

  return (
    <Container className='text-center error-update-payment'>
      <Row className='start-point d-block title'>
        <p>עדכון אמצעי תשלום</p>
      </Row>

      <Row className='bold main-text d-block'>{renderErrorReason()}</Row>
      {props.data.isBusinessBlock && (
        <Row>
          <Col>
            <p className='start-point d-block'> אפשר לעדכן את אמצעי התשלום דרך מוקד השירות שלנו</p>
          </Col>
        </Row>
      )}

      {!props.data.isBusinessBlock &&
        failedUpdates &&
        !allUpdatesFailed && ( // render view in case some updates failed in private flow
          <Row>
            <Col>{renderUpdatedAccountsReport()}</Col>
          </Row>
        )}
      <Row>
        {!props.data.isBusinessBlock ? (
          renderErrorIcon()
        ) : (
          <Col>
            <Image src={images.bitmap} alt='error' className='failure-image-container' />
          </Col>
        )}
      </Row>
      {!props.data.isBusinessBlock && (
        <Row className='failure-try-again-container'>
          <Col>{renderTryAgainDescription()}</Col>
        </Row>
      )}
      <Row className='failure-call-button-container'>
        <Col>{renderRelevantDialToNumber()}</Col>
      </Row>
      <Row>
        <Col xs={12} className={`btn-290 btn-row`}>
          <BtnSubmit isBusiness={props.data.isBusinessBlock} text='סיום' onclick={() => backToLobby()} />
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorComponent;
